const { isEmptyOrNotSet, findByAddress, isset } = require('@hints/utils/data');
const { round, ratio } = require('@hints/utils/math');

const UNIT_SETTINGS = {
    weight: {
        si: {
            ratioToSystem: 1,
            unitSuffix: 'kg'
        }, 
        imperial: {
            ratioToSystem: 2.20462,
            unitSuffix: 'lbs'
        },
    },
    height: {
        si: {
            ratioToSystem: 1,
            unitSuffix: 'cm'
        },
        imperial: {
            ratioToSystem: (1 / 2.54),
            unitSuffix: 'in'
        }
    },
    neck: {
        si: {
            ratioToSystem: 1,
            unitSuffix: 'cm'
        },
        imperial: {
            ratioToSystem: (1 / 2.54),
            unitSuffix: 'in'
        }
    }
};

function getValueFromSystem(type, value, system) {
    if(isEmptyOrNotSet(value)) return undefined;
    const ratioValueToSystem = _getSystemRatio(type, system);
    const ratioValueFromSystem = ratio(1, ratioValueToSystem);
    return round(value * ratioValueFromSystem, 0);
} 

function getValueInSystem(type, value, system) {
    if(isEmptyOrNotSet(value)) return undefined;
    const ratioValueToSystem = _getSystemRatio(type, system);
    return round(value * ratioValueToSystem, 0);
}

function formatValueInSystem(type, value, system) {
    const systemUnit = _getSystemSuffix(type, system);
    const valueInSystem = getValueInSystem(type, value, system);
    if(!isset(valueInSystem)) return undefined;
    return `${valueInSystem} ${systemUnit}`;
}

module.exports = {
    getValueFromSystem,
    getValueInSystem,
    formatValueInSystem,
};

function _getSystemRatio(type, system) {
    if(isEmptyOrNotSet(system)) system = 'si';
    if(isEmptyOrNotSet(type)) return 1;
    return findByAddress(UNIT_SETTINGS, `${type}.${system}.ratioToSystem`, 1);
}

function _getSystemSuffix(type, system) {
    if(isEmptyOrNotSet(system)) system = 'si';
    if(isEmptyOrNotSet(type)) return 1;
    return findByAddress(UNIT_SETTINGS, `${type}.${system}.unitSuffix`, 1);
}